import { useCallback, useContext, useEffect, useState } from 'react';
import AuthContext from './Auth';
import { useHistory } from 'react-router';
import Header from './Header';
import AlertContext from './Alert';
import styles from '../css/Login.module.scss';
import QRCode from 'qrcode';
import apiUrl from '../assets/apiUrl';
import {
  Avatar,
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { LockOpenOutlined } from '@material-ui/icons';
import { useLocation } from 'react-router-dom';

const Login = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const history = useHistory();
  const { login: performLogin, logout, _login } = useContext(AuthContext);
  const { show } = useContext(AlertContext);
  const [qrSrc, setQrSrc] = useState('');
  const [mounted, setMounted] = useState(true);
  const location = useLocation();
  const redirect = () => {
    // Check if ref query parameter exists, if yes redirect the user
    // to it, otherwise redirect to dashboard
    // NOTE: ref parameter has to be an absolute url
    const queryParams = new URLSearchParams(location.search);
    const refValue = queryParams.get('ref');
    refValue ? (window.location.href = refValue) : history.push('/');
  };
  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await performLogin(login, password);
      redirect();
    } catch (error: any) {
      logout();
      show({ title: 'Login failed', body: error, type: 'error' });
    }
  };
  const tryAuth = useCallback(async () => {
    setMounted((state) => {
      if (!state) return state;
      (async () => {
        const res = await fetch(`${apiUrl}/auth/qr`);
        const response = await res.json();

        const qrtoken = await QRCode.toDataURL(response.token);
        setQrSrc(qrtoken);

        try {
          const authenticated = await (
            await fetch(`${apiUrl}/auth/qr?request_id=${response.request_id}`, {
              credentials: 'include',
            })
          ).json();
          _login(authenticated.token);
          redirect();
        } catch (err) {
          tryAuth();
        }
      })();
      return state;
    });
  }, [_login, history]);
  useEffect(() => {
    tryAuth();
  }, [tryAuth]);
  useEffect(() => {
    return () => {
      setMounted(false);
    };
  }, []);
  const [isQrOpen, setIsQrOpen] = useState(false);
  const paperStyle = {
    padding: 20,
    width: 280,
    margin: '20px auto',
  };
  return (
    <div className="homepage">
      <Header />
      <div className={styles.Login}>
        <Grid>
          <Paper elevation={10} style={paperStyle}>
            <Grid container spacing={0} direction="column" alignItems="center">
              <Avatar style={{ backgroundColor: '#f6690c' }}>
                <LockOpenOutlined />
              </Avatar>
              <h2>Sign In</h2>
            </Grid>
            <form onSubmit={onSubmit}>
              <TextField
                label="email"
                placeholder="enter your email"
                fullWidth
                required
                value={login}
                onChange={(e) => setLogin(e.target.value)}
              />
              <TextField
                label="password"
                placeholder="enter password"
                type="password"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Typography align="right" style={{ margin: '16px 0' }}>
                <Link href="forgot_password">Forgot password?</Link>
              </Typography>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                fullWidth
              >
                Login
              </Button>
            </form>
            <Typography style={{ margin: '16px 0' }}>
              <Link href="signup">Create an account</Link>
            </Typography>
            <Typography style={{ margin: '8px 0' }}>
              <Link href="#qr" onClick={() => setIsQrOpen(true)}>
                Sign in using QR
              </Link>
            </Typography>
          </Paper>
        </Grid>
        <Dialog
          open={isQrOpen}
          onClose={() => setIsQrOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">QR Auth</DialogTitle>
          <DialogContent>
            <img src={qrSrc} alt="qr auth code failed to load" />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setIsQrOpen(false)}
              color="primary"
              autoFocus
            >
              close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default Login;
